(function () {
  'use strict';
  document.querySelectorAll('[data-cart-quantity]').forEach(control => {
    const input = control.querySelector('input');
    const minus = control.querySelector('[data-quantity-change="-1"]');
    function changed() {
      minus.disabled = !Number.isFinite(input.valueAsNumber) || input.valueAsNumber <= 1;
      const note = control.closest('form').querySelector('[data-cart-update-note]');
      if (note) note.textContent = 'Quantity changed. Select Update cart to refresh your total.';
    }
    control.querySelectorAll('[data-quantity-change]').forEach(button => button.addEventListener('click', () => {
      const current = Number.isFinite(input.valueAsNumber) ? input.valueAsNumber : 1;
      input.value = String(Math.max(1, Math.floor(current) + Number(button.dataset.quantityChange)));
      changed();
    }));
    input.addEventListener('input', changed);
  });
  const keys = ['sap.client', 'sap.client_requires_password', 'sap_customer_email', 'sap.client_token', 'sap.client_token_exp'];
  const blank = () => Object.fromEntries(keys.map((key, i) => [key, i === 0 ? '100' : i === 1 ? 'false' : '']));
  async function request(url, options) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(url, {...options, signal: controller.signal});
      const data = await response.json();
      if (!response.ok) throw Object.assign(new Error('Request failed'), {data});
      return data;
    } finally { clearTimeout(timer); }
  }
  const post = (url, body) => request(url, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(body)});
  const cartRoot = window.Shopify?.routes?.root || '/';
  const root = document.querySelector('[data-erp-client-selector]');
  if (root) {
    const field = name => root.querySelector('[data-field="' + name + '"]');
    const role = name => root.querySelector('[data-role="' + name + '"]');
    const select = field('client'), email = field('email'), password = field('password');
    const form = root.closest('form');
    const checkout = form.querySelector('[name="checkout"]');
    const status = role('status');
    const savedClient = root.dataset.savedClient || '100';
    if (/^\d{3}$/.test(savedClient) && savedClient !== '100') {
      if (!Array.from(select.options).some(option => option.value === savedClient)) {
        select.add(new Option('Client '+savedClient, savedClient));
      }
      select.value = savedClient;
    }
    let clientUnavailable = false;
    let clients = [], revision = 0, token = '', exp = 0, verified = false, saved = false, busy = false;
    let writeQueue = Promise.resolve(), expiryTimer;
    const isDefault = () => select.value === '100';
    const complete = () => isDefault() || (!clientUnavailable && verified && saved && exp > Date.now() + 5000 && !busy);
    const attrs = () => isDefault() ? blank() : {
      'sap.client':select.value, 'sap.client_requires_password':'true',
      'sap_customer_email':email.value.trim().toLowerCase(), 'sap.client_token':token,
      'sap.client_token_exp':exp ? String(exp) : ''
    };
    function message(text, error) { status.textContent = text; status.dataset.error = error ? 'true' : 'false'; }
    function sync() {
      const current = attrs();
      keys.forEach(key => { form.querySelector('[data-client-attribute="'+key+'"]').value = current[key]; });
      role('protected').hidden = isDefault();
      role('selection-label').textContent = isDefault() ? 'Choose the client for this purchase.' : 'Client '+select.value+' · Dedicated-client access';
      root.querySelector('.erp-client-choice__scope').hidden = !isDefault();
      checkout.disabled = !complete();
      checkout.setAttribute('aria-describedby', 'sap-client-status');
      role('verify').disabled = busy || clientUnavailable;
      email.required = password.required = !isDefault();
      email.disabled = password.disabled = isDefault();
    }
    function persist(version = revision) {
      const current = attrs(); saved = false; sync();
      writeQueue = writeQueue.catch(() => {}).then(async () => {
        if (version !== revision) return;
        const cart = await post(cartRoot+'cart/update.js', {attributes:current});
        if (version !== revision) return;
        if (!keys.every(key => String(cart.attributes?.[key] || '') === current[key])) throw new Error('Selection was not saved');
        saved = true; sync();
      }).catch(() => {
        if (version !== revision) return;
        saved = false; sync();
        message(isDefault() ? 'Ready for checkout.' : 'We could not save your client choice. Please verify again.', !isDefault());
      });
      return writeQueue;
    }
    function invalidate() {
      revision++; verified = saved = busy = false; token = ''; exp = 0;
      clearTimeout(expiryTimer); sync();
    }
    select.addEventListener('change', () => {
      clientUnavailable = false;
      invalidate(); password.value = ''; sync();
      message(isDefault() ? 'Ready for checkout.' : 'Enter the checkout email and the client password supplied in your instructions.');
      persist();
    });
    [email, password].forEach(input => input.addEventListener('input', () => {
      invalidate(); message('Verify your client before checkout.'); persist();
    }));
    async function verify() {
      if (busy || isDefault() || clientUnavailable) return;
      if (!email.reportValidity() || !password.reportValidity()) return;
      const version = ++revision;
      token = ''; exp = 0; saved = verified = false; busy = true; sync();
      message('Checking client access…');
      try {
        const result = await post(root.dataset.apiBase.replace(/\/$/, '')+'/checkout/validate-client', {
          client:select.value, email:email.value.trim().toLowerCase(), password:password.value
        });
        if (version !== revision) return;
        if (!result.ok || result.client !== select.value || !result.token || !(Number(result.exp) > Date.now()+5000)) throw new Error('Invalid verification');
        token = result.token; exp = Number(result.exp); verified = true; busy = false;
        await persist(version);
        if (version !== revision) return;
        if (saved) message('Client '+select.value+' verified. Use this same email at checkout.');
        expiryTimer = setTimeout(() => { invalidate(); message('Verification has expired. Please verify again.', true); persist(); }, Math.max(0,exp-Date.now()-5000));
      } catch (error) {
        if (version !== revision) return;
        busy = verified = false; token = ''; exp = 0;
        const data = error.data || {};
        message(data.reason === 'bad_password' ? 'The client password is incorrect. Please try again.' : data.reason === 'pinned' ? 'This email already uses another client. Use your existing client or contact support.' : 'We could not verify this client. Check your details and try again.', true);
        sync();
      }
    }
    role('verify').addEventListener('click', verify);
    [email,password].forEach(input => input.addEventListener('keydown', event => { if(event.key === 'Enter'){event.preventDefault();verify();} }));
    async function loadClients() {
      role('retry').hidden = true;
      const currentClient = select.value;
      const version = revision;
      try {
        const result = await request(root.dataset.apiBase.replace(/\/$/, '')+'/checkout/clients');
        if (version !== revision) { role('retry').hidden = false; return; }
        if (!Array.isArray(result.clients)) throw new Error('Invalid client list');
        clients = result.clients.filter(c => /^\d{3}$/.test(String(c.client_number)));
        // 100 is the standard public route. All other routes require verification.
        const standard = clients.find(c => String(c.client_number) === '100');
        select.replaceChildren(new Option(standard ? '100 · '+standard.label : '100', '100'));
        clients.filter(c => String(c.client_number) !== '100').forEach(c => select.add(new Option(c.client_number+' · '+c.label, String(c.client_number))));
        clientUnavailable = currentClient !== '100' && !clients.some(c => String(c.client_number) === currentClient);
        if (clientUnavailable) {
          const unavailable = new Option('Client '+currentClient+' · Unavailable', currentClient);
          unavailable.disabled = true;
          select.add(unavailable);
          select.value = currentClient;
          invalidate();
        } else select.value = currentClient;
        select.disabled = select.options.length <= 1;
        sync();
        if (clientUnavailable) message('Your selected client is unavailable. Choose the client in your instructions or contact support.', true);
        else if (isDefault()) message('Ready for checkout.');
        else if (!verified) message('Verify your selected client before checkout.');
      } catch (_) {
        role('retry').hidden = false;
        if (version !== revision) return;
        message(isDefault() ? 'Client 100 is ready. Other client choices could not load; retry if you need one.' : 'Your client choice was kept. Other client choices could not load; retry or contact support.', !isDefault());
      }
    }
    role('retry').addEventListener('click', loadClients);
    let handingOff = false;
    form.addEventListener('submit', async event => {
      if (window.erpCartMutationPending) {
        event.preventDefault();
        message('Please wait for your cart update to finish.', true);
        return;
      }
      if (event.submitter?.name === 'update') return;
      if (handingOff) return;
      if (!complete()) {event.preventDefault(); message('Please verify your selected client before checkout.', true); email.focus();}
      else {
        event.preventDefault();
        // Finish any older write before the native form saves the current choice.
        await writeQueue;
        if (window.erpCartMutationPending || !complete()) return;
        // Resume after the original submit event has finished; browsers ignore a
        // nested requestSubmit while that event is still being dispatched.
        setTimeout(() => {
          if (window.erpCartMutationPending || !complete()) return;
          sync(); handingOff = true;
          try { form.requestSubmit(checkout); } finally { handingOff = false; }
        }, 0);
      }
    });
    window.erpSapClientGate = {complete, persist, isDefault};
    sync(); loadClients();
  } else {
    const nativeForm = document.querySelector('.sap-cart-form');
    if (nativeForm) nativeForm.addEventListener('submit', event => {
      if (!window.erpCartMutationPending) return;
      event.preventDefault();
      const note = nativeForm.querySelector('[data-cart-update-note]');
      if (note) note.textContent = 'Please wait for your cart update to finish.';
    });
  }
  document.querySelectorAll('[data-cart-checkout]').forEach(link => {
    let opening = false;
    link.addEventListener('click', async event => {
      event.preventDefault();
      if (window.erpCartMutationPending || opening) return;
      opening = true; link.setAttribute('aria-busy','true');
      try {
        let cart = await request(cartRoot+'cart.js');
        const dedicatedOnly = Array.isArray(cart.items) && cart.items.length > 0 && cart.items.every(item => item.handle === 'client' || item.sku === 'CLIENT-250');
        if (dedicatedOnly) {
          await post(cartRoot+'cart/update.js', {attributes:blank()});
          if (window.erpCartMutationPending || (root && !window.erpSapClientGate.complete())) return;
          window.location.assign(link.href);
          return;
        }
        if (root) {
          if (!window.erpSapClientGate.complete()) {window.location.assign(cartRoot+'cart'); return;}
          await window.erpSapClientGate.persist();
          if (!window.erpSapClientGate.complete()) {window.location.assign(cartRoot+'cart'); return;}
          cart = await request(cartRoot+'cart.js');
        }
        const a = cart.attributes || {};
        if (a['sap.client'] && a['sap.client'] !== '100') {
          if (!a['sap.client_token'] || Number(a['sap.client_token_exp']) <= Date.now()+5000) { window.location.assign(cartRoot+'cart'); return; }
        } else {
          await post(cartRoot+'cart/update.js', {attributes:blank()});
        }
        if (window.erpCartMutationPending || (root && !window.erpSapClientGate.complete())) return;
        window.location.assign(link.href);
      } catch (_) { window.location.assign(cartRoot+'cart'); }
      finally { opening = false; link.removeAttribute('aria-busy'); }
    });
  });
})();
